{
  "cms.catalogRow.actions.menu": "Actions",
  "cms.catalogRow.action.publish": "Publish",
  "cms.catalogRow.action.unpublish": "Unpublish",
  "cms.catalogRow.publishError": "Publish failed. Try again.",
  "cms.catalogRow.unpublishError": "Unpublish failed. Try again.",
  "cms.catalog.action.createMenu": "New",
  "cms.catalog.action.createOption.articleTeaser": "Home card or button",
  "cms.catalog.action.createOption.benefit": "Benefit or discount",
  "cms.catalog.action.createOption.videoListing": "Lakiruutu-video",
  "cms.catalog.badge.orphaned": "Not linked",
  "cms.catalog.unit.benefitDefaultCategory": "Other benefits",
  "cms.catalog.unit.group.benefits": "Benefits and discounts",
  "cms.catalog.unit.group.buttons": "Home buttons",
  "cms.catalog.unit.group.cards": "Home cards",
  "cms.catalog.unit.group.videos": "Lakiruutu videos",
  "cms.catalog.empty": "No content yet.",
  "cms.catalog.errorState": "Failed to load content catalog.",
  "cms.catalog.group.draft": "Drafts",
  "cms.catalog.group.orphanedHomeCards": "Home cards without an article",
  "cms.catalog.group.published": "Published",
  "cms.catalog.loading": "Loading content…",
  "cms.catalog.title": "Content management",
  "cms.catalog.badge.unpublishedContentChanges": "Unpublished content changes",
  "cms.fixedEntry.lakikaveriInfo": "About Lakikaveri",
  "cms.fixedEntry.oikeusturvavakuutus": "Legal expenses insurance",
  "cms.fixedEntry.eduhousenVerkkokoulutus": "Online training service",
  "cms.fixedEntry.vapaaAjanTapaturmavakuutus": "Accident insurance",
  "cms.fixedEntry.jasenedut": "Benefits and discounts",
  "cms.fixedEntry.lakiruutu": "Lakiruutu videos",
  "cms.fixedEntries.title": "Fixed page templates",
  "cms.fixedEntries.empty": "No content in the selected language.",
  "cms.fixedEntries.loading": "Loading fixed page templates…",
  "cms.fixedEntries.error": "Loading fixed page templates failed.",
  "cms.fixedEntries.discardStagedEdit": "Discard staged changes",
  "cms.fixedEntries.discardInitial.confirm.title": "Discard changes?",
  "cms.fixedEntries.discardInitial.confirm.body": "The drafted changes are permanently removed. The fixed page remains available to author again.",
  "cms.fixedEntries.discardInitial.confirm.confirm": "Discard changes",
  "cms.fixedEntries.copyFromFiToLocale.sv": "Copy Finnish content to a Swedish draft",
  "cms.fixedEntries.copyFromFiToLocale.en": "Copy Finnish content to an English draft",
  "cms.fixedEntries.copySourceChecking": "Checking the Finnish source content…",
  "cms.fixedEntries.copySourceUnavailable": "The Finnish source is unavailable. A draft cannot be copied to the selected language.",
  "cms.fixedEntries.copyFailed": "Copying Finnish content to the selected language draft failed.",
  "cms.tabs.julkaistut": "Published",
  "cms.tabs.luonnokset": "Drafts",
  "cms.tabs.sivupohjat": "Saved page templates",
  "cms.templates.cancel": "Cancel",
  "cms.templates.create": "Save template",
  "cms.templates.heading": "Saved page templates",
  "cms.templates.delete": "Delete template",
  "cms.templates.delete.confirm": "Delete template",
  "cms.templates.delete.confirmAction": "Delete",
  "cms.templates.delete.description": "The template is permanently removed from Page templates. The original page and pages created from this template remain unchanged.",
  "cms.templates.delete.error": "Deleting the template failed.",
  "cms.templates.delete.title": "Delete template",
  "cms.templates.empty": "Save a template from an existing published or draft page.",
  "cms.templates.error": "Loading page templates failed.",
  "cms.templates.loadMore": "Show more templates",
  "cms.templates.loading": "Loading page templates…",
  "cms.templates.locale.en": "English",
  "cms.templates.locale.fi": "Finnish",
  "cms.templates.locale.sv": "Swedish",
  "cms.templates.type.contentPage": "Content page",
  "cms.templates.name": "Template name",
  "cms.templates.editor.preview": "Preview",
  "cms.templates.editor.previewDescription": "Preview of the template you are editing.",
  "cms.templates.error.notFound": "The template no longer exists. Refresh the list.",
  "cms.templates.error.stale": "The template changed in another session. Refresh the list before trying again.",
  "cms.templates.editor.error.unknown": "The save result is unknown. The template will not be saved again automatically.",
  "cms.templates.editor.back": "Back to page templates",
  "cms.templates.editor.helper": "Edit template content. These changes do not change pages.",
  "cms.templates.editor.open": "Edit template",
  "cms.templates.editor.readOnly": "You do not have permission to edit this template.",
  "cms.templates.editor.reload": "Load latest version",
  "cms.templates.editor.save": "Save",
  "cms.templates.editor.saving": "Saving…",
  "cms.templates.editor.title": "Edit template",
  "cms.templates.rename": "Rename",
  "cms.templates.rename.error": "Renaming the template failed.",
  "cms.templates.rename.required": "Enter a template name.",
  "cms.templates.rename.save": "Save name",
  "cms.templates.rename.description": "Enter a new name for the template.",
  "cms.templates.rename.title": "Rename template",
  "cms.templates.retry": "Try again",
  "cms.templates.source.description": "Choose a published or draft page whose content will be saved as a template.",
  "cms.templates.source.close": "Close",
  "cms.templates.source.empty": "No eligible content pages.",
  "cms.templates.source.error": "Loading content pages failed.",
  "cms.templates.source.error.changed": "The selected page changed. Select it again.",
  "cms.templates.source.error.inspect": "Checking the page failed.",
  "cms.templates.source.error.inspectCandidates": "Checking page templates failed.",
  "cms.templates.source.error.nameExists": "A template with the same name already exists in this language.",
  "cms.templates.source.error.unavailable": "The selected page can no longer be used. Choose another page.",
  "cms.templates.source.inspecting": "Checking the selected page…",
  "cms.templates.source.loading": "Loading content pages…",
  "cms.templates.source.kind.draft": "Draft",
  "cms.templates.source.kind.published": "Published",
  "cms.templates.source.candidateFound": "Found a template with the same name:",
  "cms.templates.source.candidateUncertain": "This does not confirm that this save succeeded.",
  "cms.templates.source.inspectCandidates": "Check page templates",
  "cms.templates.source.helper": "The template is created from the selected page content (published or draft).",
  "cms.templates.source.nameLabel": "Name",
  "cms.templates.source.namePlaceholder": "Template name",
  "cms.templates.source.newCreate": "Start a new save",
  "cms.templates.source.noCandidate": "No template with the same name was found. This does not confirm that the save rolled back.",
  "cms.templates.source.pageLabel": "Select content page",
  "cms.templates.source.pagePlaceholder": "Select page…",
  "cms.templates.source.reinspect": "Check the selected page again",
  "cms.templates.source.save": "Save",
  "cms.templates.source.title": "New template",
  "cms.templates.source.unknown": "The save result is unknown."
}
